// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3vB0a","title":"AfterFrontImage_title__1jRGU"};